module.exports = __webpack_public_path__ + "static/img/伙伴客户-上海中医院.2ba6a029.png";